import type { Level } from '@/api/types';

// 게임 행의 변경 상태 — 신규 부여 / 역할 변경 / 회수.
export type ChangeKind = 'grant' | 'update' | 'revoke';

// diff 한 항목 — 대상 게임(project_id)과 적용 level.
export interface PermChangeEntry {
  projectId: string;
  level: Level;
}

// 기존 권한 대비 변경 분류 결과.
export interface PermDiff {
  toGrant: PermChangeEntry[];
  toUpdate: PermChangeEntry[];
  toRevoke: PermChangeEntry[];
}

// 같은 level끼리 project_id를 묶어 요청 수를 최소화.
export function groupByLevel(items: PermChangeEntry[]): Record<string, string[]> {
  const map: Record<string, string[]> = {};
  for (const { projectId, level } of items) {
    (map[level] ??= []).push(projectId);
  }
  return map;
}

// 변경 요약 텍스트 — "신규 2 · 변경 1 · 회수 3"
export function changeSummary(diff: PermDiff): string {
  const parts: string[] = [];
  if (diff.toGrant.length > 0) parts.push(`신규 ${diff.toGrant.length}`);
  if (diff.toUpdate.length > 0) parts.push(`변경 ${diff.toUpdate.length}`);
  if (diff.toRevoke.length > 0) parts.push(`회수 ${diff.toRevoke.length}`);
  return parts.join(' · ');
}
